module.exports = __webpack_public_path__ + "static/media/hotel2.31c5e618.png";